export const MenuColumns = [
  {
    title: "Text",
    dataIndex: "text",
    key: "text",
  },
  {
    title: "url",
    dataIndex: "url",
    key: "url",
  },
  {
    title: "Parent Menu",
    dataIndex: "parent",
    key: "parent",
  },
  {
    title: "Open In new Window",
    dataIndex: "newWindow",
    key: "newWindow",
  },
  {
    title: "",
    dataIndex: "actionButtons",
    key: "actionButtons",
  }
]

export const ContentKeysColumns = [
  {
    title: "System Id",
    dataIndex: "stringId",
    key: "stringId",
  },
  {
    title: "Text",
    dataIndex: "value",
    key: "value",
  },
  {
    title: "",
    dataIndex: "actionButtons",
    key: "actionButtons",
  }
]